<div class="max-w-full overflow-hidden">
    <div class="relative">
        <ui-m000-c030-checkout-wrapper #wrapper identifier="service">
            <app-service-form-list-step title="Servicelist" />
            @defer {
                <app-service-form-contact-step title="Kontakt" />
                <app-service-form-thanks-step title="Dankesseite" />
            }
        </ui-m000-c030-checkout-wrapper>
    </div>
</div>
